import config from "config"
import configure from "configure"
import React from "react"
import { Navigate } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"

const Authmiddleware = (props) => {
  if (!secureLocalStorage.getItem("User")) {
    return (
      <Navigate to={{ pathname: `${configure.appUrl}/login`, state: { from: props.location } }} />
    )
  }
  return (<React.Fragment>
    {props.children}
  </React.Fragment>)
}

export default Authmiddleware
